<template>
<div v-if="sponsor" class="list-item"
    v-bind:class="{ 'list-item-payment-complete': s.participationStatus === 'Paid' }">
    <div class="left-part">
        <span 
            class="icon"
            v-bind:class="{
                'icon-checkmark': s.participationStatus === 'Paid',
                'icon-notification' : s.participationStatus === 'Participates',
                'icon-question': s.participationStatus === 'NotAnswered' || s.participationStatus === 'Refused' }">
        </span>
    </div>

    <div class="right-part">
        <div class="information-block">
            <div>{{ s.fullName }}</div>
            <div>{{ s.email }}</div>
            <div v-if="s.participationStatus === 'NotAnswered' && s.invitedOn">
                <span>{{ $t("sponsorsView.invitedOn", [ dateDisplay(s.invitedOn) ]) }}</span>
            </div>

            <div v-if="s.participationStatus === 'Participates' || s.participationStatus === 'Paid'">
                <span v-if="s.paymentMethod === 'PerRepeat'">{{ $t("sponsorsView.paymentPerRepeat", [ s.payment ]) }}</span>
                <span v-else-if="s.paymentMethod === 'Manual'">{{ $t("sponsorsView.paymentManual", [ s.payment ]) }}</span>
            </div>
        </div>
        <div class="action-block">
            <template v-if="canSendBill && !s.billSentOn && s.participationStatus == 'Participates'">
                <div v-if="s.participationStatus == 'Participates'">
                    <button type="button" class="button button-small" @click="$emit('bill', s)">
                        {{ $t("sponsorsView.sendBill") }}
                    </button>
                </div>
            </template>
            <template v-else>
                <button 
                    v-if="s.participationStatus === 'Participates' && isNotificationAllowed(s)"
                    :disabled="!s.billSentOn || s.sendingEmail"
                    class="button button-small"
                    @click="$emit('reminder', s)">
                        <span class="icon icon-bell"></span>
                        <span>{{ $t("sponsorsView.sendReminder") }}</span>
                </button>

                <div v-if="s.participationStatus === 'Participates' && !isNotificationAllowed(s)">
                    <span v-if="isNotificationAllowed(s)" class="icon icon-bell"></span>
                    <span v-if="s.notificationSentOn">{{ $t("sponsorsView.reminderSent", [ dateDisplay(s.notificationSentOn) ]) }}</span>
                    <span v-else-if="s.billSentOn">{{ $t("sponsorsView.billSent", [ dateDisplay(s.billSentOn) ]) }}</span>
                </div>
                <div v-else-if="s.participationStatus === 'Paid'">
                    <span>{{ $t("sponsorsView.paymentCompleted") }}</span>
                </div>

                <button
                    v-else-if="s.participationStatus === 'NotAnswered' && isInvitationAllowed(s)"
                    :disabled="s.sendingEmail"
                    class="button button-small"
                    @click="$emit('reInvite', s)">
                        <span class="icon icon-mail4"></span>
                        <span v-if="s.invitedOn">{{ $t("sponsorsView.inviteAgain") }}</span>
                </button>
                <!--
                <div v-else-if="s.participationStatus === 'Refused'">
                    <span>{{ $t("sponsorsView.notParticipating") }}</span>
                </div>
                -->
            </template>
        </div>
    </div>
</div>
</template>


<script lang="ts">
import { Sponsor } from "store";
import { isNotificationAllowed, isInvitationAllowed } from "common";
import { store } from "store";
import { defineComponent, PropType } from "vue";

export default defineComponent({
    data() {
        return {
            s: this.sponsor,
            isNotificationAllowed: isNotificationAllowed,
            isInvitationAllowed: isInvitationAllowed
        };
    },
    computed: {
        canSendBill() {
            return store.selectedEvent.eventParticipant.canSendBill;
        }
    },
    methods: {
        dateDisplay(date: Date) {
            return date ? this.$d(new Date(date)) : "";
        }
    },
    props: {
        sponsor: {
            type: Object as PropType<Sponsor>
        }
    }
})
</script>